














import ThgChargingStationCard from "@/components/thg/ThgChargingStationCard.vue";
import LayoutSimple from "@/layouts/LayoutSimple.vue";
import { ChargingStationModule } from "@/store/modules/charging-station.store";
import { Component, Vue } from "vue-property-decorator";
import { HttpException } from "@/lib/exceptions/http";
import { ThgChargingStationViewModelGen, ThgThgMeterReadingViewModelGen } from "@/services/thg/v1/data-contracts";
import { MeterReadingModule } from "@/store/modules/meter-reading.store";

@Component({
  components: {
    LayoutSimple,
    ThgChargingStationCard
  }
})
export default class ThgChargingStationDetail extends Vue {
  isLoading = true;

  async mounted() {
    try {
      this.isLoading = true;
      await MeterReadingModule.getMeterReadingsByChargingStation(this.$route.params.chargingStationId);
      await ChargingStationModule.getChargingStation(this.$route.params.chargingStationId);
    } catch (error) {
      this.$log.error(error);
      if (error instanceof HttpException) {
        this.$toast.error(error.message);
      }
    } finally {
      this.isLoading = false;
    }
  }

  get chargingStation(): ThgChargingStationViewModelGen | undefined {
    return ChargingStationModule.activeChargingStation;
  }

  get meterReadings(): ThgThgMeterReadingViewModelGen[] | undefined {
    return MeterReadingModule.meterReadings;
  }
}
